import { createSelector } from 'reselect';
import { allSeletedElement } from '@Selectors/builder/myArmyList/common/constraints/elements/selectable/all-seleted-element';
import {
  getArmyList,
  getArmyOrganisationGroups,
  getUnits,
} from '@Selectors/builder/myArmyList/make/unit/edit/selector/editSelector';
import { SelectedElement } from '@Models';

export const selectedElementsPresenter = createSelector(
  [getArmyList, getArmyOrganisationGroups, getUnits],
  (armyList, armyOrganisationGroups, units): SelectedElement[] => {
    return allSeletedElement(armyList, armyOrganisationGroups, units);
  },
);
